import * as localforage from "localforage";
import axios from "axios";

export const getLocalFileSettingApi = async device_id => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/device/local-file/setting`,
    method: "GET",
    params: {
      company_id,
      device_id
    }
  });
  return res.data;
};

export const enableLocalFileApi = async (device_id, json) => {
  const company_id = await localforage.getItem("companyId");
  const user = await localforage.getItem("user");
  let res = await axios({
    url: `/api/v2/device/local-file/enable`,
    method: "POST",
    data: {
      company_id,
      device_id,
      user_id: user.id,
      json
    }
  });
  return res.data;
};

export const setLocalFileLocationApi = async (
  device_id,
  files_store_location
) => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/device/local-file/store-location`,
    method: "POST",
    data: {
      company_id,
      device_id,
      files_store_location
    }
  });
  return res.data;
};

export const backupFileLocationApi = async device_id => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/command/backup-device-local-file-send`,
    method: "POST",
    data: {
      company_id,
      device_id,
      execute_type: "zip_file_upload"
    }
  });
  return res.data;
};

export const abortBackupFileLocationApi = async device_id => {
  const company_id = await localforage.getItem("companyId");
  let res = await axios({
    url: `/api/v2/device/local-file/terminate-upload`,
    method: "POST",
    data: {
      company_id,
      device_ids: [device_id],
      execute_type: "terminate_upload"
    }
  });
  return res.data;
};
